




































































import Vue from 'vue';
import Input from '../common/Input/Input.vue';
import NotificationText from '../common/NotificationText/NotificationText.vue';
import TextArea from '../common/TextArea/TextArea.vue';
import CheckBox from '../common/CheckBox/CheckBox.vue';

export default Vue.extend({
  props: ['getResult'],
  components: {
    Input,
    NotificationText,
    TextArea,
    CheckBox,
  },
  data(): {
    labelsetName: string;
    labelsetDescription: string;
    csvPath: string;
    labelsetPath: string;
    visitDirectorySection: boolean;
    visitFilenameSection: boolean;
    visitCSVSection: boolean;
    visitSingleJSONSection: boolean;
    visitMultipleJSONSection: boolean;
    /** 라벨셋 생성 정보 중 수정이 필요한 부분들 */
    errorList: {
      name: boolean;
      description: boolean;
      method: boolean;
      path: boolean;
    };
    /** 라벨셋 구조 샘플링 중 무시할 디렉토리 목록(쉼표로 구분된 문자열 형태) */
    ignoreListText?: string;
  } {
    return {
      labelsetName: '',
      labelsetDescription: '',
      csvPath: '',
      labelsetPath: '',
      visitDirectorySection: false,
      visitFilenameSection: false,
      visitCSVSection: false,
      visitSingleJSONSection: false,
      visitMultipleJSONSection: false,
      errorList: {
        name: false,
        description: false,
        method: false,
        path: false,
      },
      ignoreListText: '',
    };
  },
  methods: {
    onClickButton() {
      // 사용자 입력 form 검증 로직

      /** 수정 필요 여부를 나타내는 플래그 */
      let needFixed = false;

      // 라벨셋 이름 검증
      if (this.labelsetName === '') {
        needFixed = true;
        this.errorList.name = true;
      } else {
        this.errorList.name = false;
      }

      // 라벨셋 설명 검증
      if (this.labelsetDescription === '') {
        needFixed = true;
        this.errorList.description = true;
      } else {
        this.errorList.description = false;
      }

      // 라벨셋 형식 선택 검증
      if (
        !this.visitDirectorySection &&
        !this.visitFilenameSection &&
        !this.visitCSVSection &&
        !this.visitSingleJSONSection &&
        !this.visitMultipleJSONSection
      ) {
        needFixed = true;
        this.errorList.method = true;
      } else {
        this.errorList.method = false;
      }

      // 라벨셋 형식이 파일 디렉토리와 관련된 경우 파일 디렉토리 검증
      this.errorList.path = false;
      if (this.visitCSVSection && this.csvPath === '') {
        needFixed = true;
        this.errorList.path = true;
      }
      if (
        (this.visitSingleJSONSection || this.visitMultipleJSONSection) &&
        this.labelsetPath === ''
      ) {
        needFixed = true;
        this.errorList.path = true;
      }

      /** 사용자 입력 검증 결과 */
      let result: {
        ok: boolean;
        labelsetName?: string;
        labelsetDescription?: string;
        csvPath?: string;
        labelsetPath?: string;
        visitDirectorySection?: boolean;
        visitFilenameSection?: boolean;
        visitCSVSection?: boolean;
        visitSingleJSONSection?: boolean;
        visitMultipleJSONSection?: boolean;
        ignoreList?: string;
      } = {
        ok: !needFixed,
        labelsetName: this.labelsetName,
        labelsetDescription: this.labelsetDescription,
        csvPath: this.csvPath,
        labelsetPath: this.labelsetPath,
        visitDirectorySection: this.visitDirectorySection,
        visitFilenameSection: this.visitFilenameSection,
        visitCSVSection: this.visitCSVSection,
        visitSingleJSONSection: this.visitSingleJSONSection,
        visitMultipleJSONSection: this.visitMultipleJSONSection,
        ignoreList: this.ignoreListText,
      };
      this.$emit('pushResult', result);
    },
  },
  watch: {
    getResult: function (getResult) {
      if (getResult === true) {
        this.onClickButton();
      }
    },
    // #region checkboxes to radio buttons
    visitDirectorySection: function (visitDirectorySection) {
      if (visitDirectorySection) {
        this.visitFilenameSection = false;
        this.visitCSVSection = false;
        this.visitSingleJSONSection = false;
        this.visitMultipleJSONSection = false;
      }
    },
    visitFilenameSection: function (visitFilenameSection) {
      if (visitFilenameSection) {
        this.visitDirectorySection = false;
        this.visitCSVSection = false;
        this.visitSingleJSONSection = false;
        this.visitMultipleJSONSection = false;
      }
    },
    visitCSVSection: function (visitCSVSection) {
      if (visitCSVSection) {
        this.visitDirectorySection = false;
        this.visitFilenameSection = false;
        this.visitSingleJSONSection = false;
        this.visitMultipleJSONSection = false;
      }
    },
    visitSingleJSONSection: function (visitSingleJSONSection) {
      if (visitSingleJSONSection) {
        this.visitDirectorySection = false;
        this.visitFilenameSection = false;
        this.visitCSVSection = false;
        this.visitMultipleJSONSection = false;
      }
    },
    visitMultipleJSONSection: function (visitMultipleJSONSection) {
      if (visitMultipleJSONSection) {
        this.visitDirectorySection = false;
        this.visitFilenameSection = false;
        this.visitCSVSection = false;
        this.visitSingleJSONSection = false;
      }
    },
    // #endregion
  },
});
